<template>
<div>
  <div 
    class="file-item flex-column flex-md-row" 
    :class="{'bg-selected': isSelected(output) === true}"
    v-for="output in currentJob.apiJob?.output" v-if="complete" @click="toggleSelection(output)"
  >
    <div class="item d-inline-flex gap-10px">
      <input type="checkbox" :checked="isSelected(output)">
      <div 
        class="item hoverFileListItem" 
        @mousemove="mouseOver(output)" 
        @mouseenter="mouseEnter(output)"
        @mouseleave="mouseOut(output)"
      >
        <div class="thumb-small no-preview" v-if="canPreviewMini(output) === false || currentJob.thumbnails.small_enabled === false">
          <i class="far fa-file"></i>
        </div>
        <div 
          class="thumb-small" @click="openPreview(output)"
          :class="{'filename-cursor': canPreview(output) === true}"
          v-if="canPreviewMini(output) && currentJob.thumbnails.small_enabled === true"
        >
          <div v-if="isSmallThumbnailByOutputLoading(output)">
            <div class="preview-loading">
              <i class="far fa-file"></i>
            </div>
          </div>
          <div class="bg-checkered">
            <img id="previewed-image" class="" v-if="!isSmallThumbnailByOutputLoading(output)" :src="getThumbnailForOutput(output)">
          </div>
        </div>
      </div>
      <a
        class="filename-cursor short-text-name"
        data-toggle="tooltip"
        data-trigger="hover"
        v-bind:title="'Right-Click, Save As'| trans"
        @click.stop="download(output)"
        :href="output.download_uri"
      >{{ output.uri|getFilenameFromUrl | decodeUrl }}</a>
      <span 
        class="text-muted "
        :class="{'line-through': isCompressJob()  === true, 'd-none': (isCompressJob() === true && !isOutputSmaller(output)) || isCompressJob() === false }"
      >
        {{ getReadableSize(getInputForOutput(output).size) }}
      </span>
      <span class="text-muted">
        {{ getReadableSize(output.size) }}
      </span>
      <div class="position-relative">
        <div class="thumb-preview" v-if="hoverOutput.id === output.id">
          <div class="placeholder" v-if="isSmallThumbnailByOutputLoading(hoverOutput)">
            <div class="animated-background"></div>
          </div>
          <div class="w-100 h-100 bg-checkered">
            <img @load="imageChanged" id="previewed-image" class="w-100 h-auto" v-if="!isSmallThumbnailByOutputLoading(hoverOutput)" :src="getThumbnailForOutput(hoverOutput)">
          </div>
        </div>
      </div>
    </div>

    <div class="item">
      <i v-if="output.status === 'uploading'" class="fa fa-spin btn-loading-animation lh-inherit spinner-basic"></i>
      <i v-if="output.status === 'uploading-init'" class="far fa-cloud-upload"></i>
    </div>

    <div class="flex-grow-1 justify-content-end d-flex file-actions item align-items-center flex-wrap">
      <div v-if="isCompressJob() === true">
        <div class="compress-success m-0" v-if="isOutputSmaller(output)">
          <strong>{{ 'Compressed by' | trans }}
            {{ getCompressDiff(output).diff_perc }}%
          </strong>
        </div>
        <div class="compress-failed m-0" v-if="isOutputSmaller(output) === false">
          <strong>{{ 'Can\'t compress any further' | trans }}</strong>
        </div>
      </div>

      <div>
        <div 
          class="file-action-btn"
          data-toggle="tooltip"
          data-trigger="hover"
          @click.stop="openFileInfo(output)"
          v-bind:title="'File Info'| trans"
        >
          <svg width="16" height="20" viewBox="0 0 16 20" fill="none" xmlns="http://www.w3.org/2000/svg">
            <path d="M10 1V5C10 5.26522 10.1054 5.51957 10.2929 5.70711C10.4804 5.89464 10.7348 6 11 6H15" stroke="#2E2E2E" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"/>
            <path d="M13 19H3C2.46957 19 1.96086 18.7893 1.58579 18.4142C1.21071 18.0391 1 17.5304 1 17V3C1 2.46957 1.21071 1.96086 1.58579 1.58579C1.96086 1.21071 2.46957 1 3 1H10L15 6V17C15 17.5304 14.7893 18.0391 14.4142 18.4142C14.0391 18.7893 13.5304 19 13 19Z" stroke="#2E2E2E" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"/>
            <path d="M7 12H8V16H9M8 9H8.01" stroke="#2E2E2E" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"/>
          </svg>
          {{ 'Info' | trans }} 
        </div>
      </div>

      <div v-if="canPreview(output)">
        <div 
          class="file-action-btn"
          @click.stop="openPreview(output)"
          data-toggle="tooltip"
          data-trigger="hover"
          v-bind:title="'Preview'| trans"
        >
          <svg xmlns="http://www.w3.org/2000/svg" width="18" height="18" viewBox="0 0 24 24">
            <path fill="currentColor" d="M12 6.5a9.77 9.77 0 0 1 8.82 5.5c-1.65 3.37-5.02 5.5-8.82 5.5S4.83 15.37 3.18 12A9.77 9.77 0 0 1 12 6.5m0-2C7 4.5 2.73 7.61 1 12c1.73 4.39 6 7.5 11 7.5s9.27-3.11 11-7.5c-1.73-4.39-6-7.5-11-7.5m0 5a2.5 2.5 0 0 1 0 5a2.5 2.5 0 0 1 0-5m0-2c-2.48 0-4.5 2.02-4.5 4.5s2.02 4.5 4.5 4.5s4.5-2.02 4.5-4.5s-2.02-4.5-4.5-4.5"/>
          </svg>
          {{ 'Preview' | trans }}
        </div>
      </div>

      <div v-if="true === false">
        <div 
          class="upload-btn"
          data-toggle="tooltip"
          data-trigger="hover"
          v-bind:title="'Upload To Cloud'| trans"
        >
          <i class="far fa-cloud-upload"></i>
        </div>
      </div>

      <div>
        <a 
          class="download-btn gap-10px"
          :href="output.download_uri"
          v-bind:title="'Download'| trans"
          @click.stop="download(output)"
        >
          <svg v-if="output.status === 'enabled'" xmlns="http://www.w3.org/2000/svg" width="14" height="16" viewBox="0 0 14 16" fill="none">
            <path d="M13.5 5.64706H9.78571V0H4.21429V5.64706H0.5L7 12.2353L13.5 5.64706ZM0.5 14.1176V16H13.5V14.1176H0.5Z" fill="white"/>
          </svg>
          <i v-if="output.status === 'downloading'" class="fa fa-spin btn-loading-animation lh-inherit"></i>
          <svg v-if="output.status === 'downloaded' || output.status === 'downloaded_as_zip'" xmlns="http://www.w3.org/2000/svg" width="14" height="14" viewBox="0 0 18 18" fill="none">
            <path d="M9 1.6875C10.9394 1.6875 12.7994 2.45792 14.1707 3.82928C15.5421 5.20064 16.3125 7.0606 16.3125 9C16.3125 10.9394 15.5421 12.7994 14.1707 14.1707C12.7994 15.5421 10.9394 16.3125 9 16.3125C7.0606 16.3125 5.20064 15.5421 3.82928 14.1707C2.45792 12.7994 1.6875 10.9394 1.6875 9C1.6875 7.0606 2.45792 5.20064 3.82928 3.82928C5.20064 2.45792 7.0606 1.6875 9 1.6875ZM9 18C11.3869 18 13.6761 17.0518 15.364 15.364C17.0518 13.6761 18 11.3869 18 9C18 6.61305 17.0518 4.32387 15.364 2.63604C13.6761 0.948212 11.3869 0 9 0C6.61305 0 4.32387 0.948212 2.63604 2.63604C0.948212 4.32387 0 6.61305 0 9C0 11.3869 0.948212 13.6761 2.63604 15.364C4.32387 17.0518 6.61305 18 9 18ZM12.9727 7.34766C13.3031 7.01719 13.3031 6.48281 12.9727 6.15586C12.6422 5.82891 12.1078 5.82539 11.7809 6.15586L7.87852 10.0582L6.22617 8.40586C5.8957 8.07539 5.36133 8.07539 5.03437 8.40586C4.70742 8.73633 4.70391 9.2707 5.03437 9.59766L7.28437 11.8477C7.61484 12.1781 8.14922 12.1781 8.47617 11.8477L12.9727 7.34766Z" fill="white"/>
          </svg>
        {{ 'Download'|trans }}</a>
      </div>
    </div>
  </div>
</div>
</template>
<script>
import store from './../../../mixins/store.mixin'
import currentJob from './../../../mixins/current_job.mixin'
import PreviewManager from "../../../manager/PreviewManager";
import FIleInfoManager from "../../../manager/FIleInfoManager";
import JobManager from "../../../manager/JobManager";
import OutputSelectionManager from "../../../manager/OutputSelectionManager";
import DownloadManager from "../../../manager/DownloadManager";
import ThumbnailManager from "../../../manager/ThumbnailManager";
import Error from "../../Elements/Error.vue";
import {formatting} from "../../../../../../../helper/formatting";
import Analytics from "../../../util/Analytics";
import FeedbackFull from "../../Elements/FeedbackFull.vue";

export default {
  name: "FileListOutputs",
  props: {},
  components: {FeedbackFull, Error},
  mixins: [
    store,
    currentJob
  ],
  data() {
    return {
      hoverOutput: {id: null}
    };
  },
  mounted: function () {

  },
  created: function () {
  },
  filters: {
    getFilenameFromUrl(url) {
      let lastSlashIndex = url.lastIndexOf('/')
      return url.substring(lastSlashIndex + 1)
    },
    decodeUrl(url) {
      try {
        return decodeURIComponent(url);
      } catch (e) {
        return url;
      }
    }

  },
  methods: {
    imageChanged() {
    },
    mouseEnter(output) {
      if (PreviewManager.canPreviewMini(JobManager.getExtensionFromOutput(output), output.size) === true) {
        this.hoverOutput = output;
        //ThumbnailManager.generateThumbnail(this.currentJob, [output]);
      } else {
        this.hoverOutput = {id: null}
      }
    },
    mouseOut(e) {
      this.hoverOutput = {id: null}
    },
    mouseOver(e) {
      this.mouseEnter(e);
      //let cursor = document.getElementById("preview-img");
      //cursor.style.display = 'inherit';
    },
    getReadableSize(size) {
      return formatting.fileSize(size);
    },
    isOutputSmaller(output) {
      return JobManager.isOutputSmaller(output, this.currentJob);
    },
    getCompressDiff(output) {
      return JobManager.getOutputCompressDiff(output, this.currentJob);
    },
    isCompressJob() {
      return JobManager.isCompressJob(this.currentJob);
    },
    getInputForOutput(output) {
      let input = JobManager.getInputByOutputSource(output, this.currentJob);
      return input[0];
    },
    getThumbnailForOutput(output) {
      return ThumbnailManager.getSmallThumbnailByOutput(this.currentJob, output);
    },
    isSmallThumbnailByOutputLoading(output) {
      return ThumbnailManager.isSmallThumbnailByOutputLoading(this.currentJob, output);
    },
    generateThumbnail(output) {
      ThumbnailManager.generateThumbnail(this.currentJob, output);
    },
    download(output) {
      DownloadManager.downloadOutput(output, this.currentJob);
    },
    selectAll() {
      Analytics.send('result_action', 'select_all', this.currentJob);

      OutputSelectionManager.selectAll(this.currentJob);
    },
    deselectAll() {
      Analytics.send('result_action', 'deselect_all', this.currentJob);

      OutputSelectionManager.deselectAll(this.currentJob);
    },
    isSelected(output) {
      return OutputSelectionManager.isOutputSelected(this.currentJob, output);
    },
    toggleSelection(output) {
      OutputSelectionManager.toggleOutput(this.currentJob, output)
    },
    getRandomInt(min, max) {
      min = Math.ceil(min);
      max = Math.floor(max);
      return Math.floor(Math.random() * (max - min) + min); // The maximum is exclusive and the minimum is inclusive
    },
    openPreview(output) {
      if (this.canPreview(output) === false) {
        return;
      }

      $('[data-toggle="tooltip"]').tooltip('hide');
      PreviewManager.openPreview(this.currentJob, output);
    },
    openFileInfo(output) {
      $('[data-toggle="tooltip"]').tooltip('hide');
      FIleInfoManager.openFileInfo(this.currentJob, output);
    },
    canPreview(output) {
      return PreviewManager.canPreview(JobManager.getExtensionFromOutput(output));
    },
    canPreviewMini(output) {
      if (this.currentJob.thumbnails.small.length > 0) {
        if (this.isSmallThumbnailByOutputLoading(output) === true) {
          return false;
        }
      }

      return PreviewManager.canPreviewMini(JobManager.getExtensionFromOutput(output), output.size);
    }
  },
  computed: {}
};
</script>
<style lang="scss" scoped>
.short-text-name {
  max-width: 300px;
  text-overflow: ellipsis;
  overflow: hidden;
  white-space: nowrap;
}

.gap-10px {
  gap: 10px;
}

.filename-cursor {
  pointer-events: inherit;
  cursor: pointer;
}

.bg-selected {
  background: #f8f8ff !important;
  border-bottom: 1px solid #D9E7FD !important;
}

.thumb-small {
  background: white;
  border: 1px solid #ccc;
  border-radius: 4px;
  width: 50px;
  height: 50px;
  z-index: 10;
  overflow: hidden;

  &.no-preview {
    display: flex;
    align-items: center;
    justify-content: center;
    background: #F5F5F5;
    color: #6C757D;
    cursor: inherit;
  }
  .preview-loading {
    width: 50px;
    height: 50px;
    display: flex;
    align-items: center;
    justify-content: center;
    background: #F5F5F5;
    color: #6C757D;
    cursor: inherit;
  }

  img {
    object-fit: cover;
    width: 50px;
    height: 50px;
  }

  .placeholder {
    height: 135px !important;
    border-radius: 9px;
    overflow: hidden;
  }

  .animated-background {
    height: 135px !important;
    border-radius: 9px;
    overflow: hidden;
  }
}

.thumb-preview {
  background: white;
  border: 1px solid #ccc;
  border-radius: 4px;
  width: 150px;
  height: auto;
  position: absolute;
  right: -170px;
  top: -55px;
  padding: 5px;
  z-index: 10;

  img {
    z-index: 100;
    border-radius: 0px;
  }

  .placeholder {
    height: 135px !important;
    border-radius: 9px;
    overflow: hidden;
  }

  .animated-background {
    height: 135px !important;
    border-radius: 9px;
    overflow: hidden;
  }

  &:before {
    z-index: -1;
    content: "";
    position: absolute;
    top: 45px;
    left: -10px;
    height: 20px;
    width: 20px;
    background: white;
    transform: rotate(45deg);
    border-left: 1px solid #ccc;
    border-bottom: 1px solid #ccc;
  }
}

.bg-checkered{
    background-image:
      linear-gradient(45deg, #ccc 25%, transparent 25%), 
      linear-gradient(135deg, #ccc 25%, transparent 25%),
      linear-gradient(45deg, transparent 75%, #ccc 75%),
      linear-gradient(135deg, transparent 75%, #ccc 75%);
    background-size:10px 10px; /* Must be a square */
    background-position:0 0, 5px 0, 5px 5px, 0px 5px; /* Must be half of one side of the square */
  }

.placeholder {
  margin: 0;
  width: 100%;
  max-width: 1400px;
  background-color: #eee;
  border-radius: 4px !important;
  overflow: hidden;
}

@keyframes placeHolderShimmer {
  0% {
    background-position: -468px 0
  }
  100% {
    background-position: 1468px 0
  }
}

.animated-background {
  animation-duration: 1.25s;
  animation-fill-mode: forwards;
  animation-iteration-count: infinite;
  animation-name: placeHolderShimmer;
  animation-timing-function: linear;
  background: darkgray;
  background: linear-gradient(to right, #eeeeee 10%, #dddddd 18%, #eeeeee 33%);
  background-size: 2800px 104px;
  height: 100%;
  position: relative;
  top: 0;
}


#preview-img {
  transition: width 2s, height 4s;
  background: white;
  border: 1px solid #ccc;
  display: none;
  width: 100px;
  height: auto;
  z-index: 1000;
  padding: 5px;
  position: absolute;
  max-height: 300px;
  overflow: hidden;
}

.line-through {
  text-decoration: line-through;
}

.spinner-basic {
  border: 2px solid #2e2e2e;
  border-right-color: transparent;

  .dark-mode & {
    border: 2px solid white;
    border-right-color: transparent;
  }
}

.global-actions-container-top {
  border-bottom: 1px solid #CBCBCB;

  .dark-mode & {
    border-bottom: 1px solid #595959;
  }
}

.global-actions-container {
  padding: 10px;

  .dark-mode & {
    background: #272727;
    color: white;
  }
}

.feedback-full {
  background: white;
  border: 1px solid #CBCBCB;
  border-radius: 4px;
  padding: 20px;
}

.file-container {
  border: 1px solid #CBCBCB;
  border-radius: 4px;
  width: 100%;
  background: #FBFBFB;

  .dark-mode & {
    border: 1px solid #595959;
  }
}

.file-actions {
  gap: 10px;
}

.file-item {
  .item {
    display: flex;
    align-items: center;
  }

  vertical-align: center;
  padding: 10px;
  display: flex;
  gap: 5px;
  background: white;
  border-bottom: 1px solid #CBCBCB;

  .dark-mode & {
    background: #272727;
    border-bottom: 1px solid #595959;
    color: white;
  }
}

.download-btn {
  cursor: pointer;
  background: #1266F1;
  color: white;
  display: flex;
  align-items: center;
  justify-content: center;
  height: 35px;
  padding: 0 10px;
  border-radius: 4px;
}

.upload-btn {
  cursor: pointer;

  i {
    line-height: inherit;
  }

  background: #F2F2F2;
  border: 1px solid #CBCBCB;
  color: black;
  display: flex;
  align-items: center;
  justify-content: center;
  height: 35px;
  padding: 0 10px;
  border-radius: 4px;
}

.file-action-btn {
  background: #F8F9FA;
  border: 1px solid #CBCBCB;
  display: flex;
  gap: 10px;
  align-items: center;
  justify-content: center;
  height: 35px;
  padding: 0 10px;
  border-radius: 4px;
  cursor: pointer;

  &:hover {
    background: #F2F2F2;
  }

  .dark-mode & {
    background: #383838;;
    border: 1px solid #595959;
    color: white;

    &:hover {
      background: #323232;
    }
  }
}

.compress-success {
  background: #CCF4DC;
  color: #0B7335;
  border: 1px solid #0B7335;
  display: flex;
  align-items: center;
  justify-content: center;
  height: 35px;
  padding: 0 10px;
  border-radius: 4px;
}

.compress-failed {
  background: #F2F2F2;
  border: 1px solid #CBCBCB;
  color: #6C757D;
  font-size: 12px;
  font-weight: normal;
  display: flex;
  align-items: center;
  justify-content: center;
  height: 35px;
  padding: 0 10px;
  border-radius: 4px;
}

.placeholder {
  margin: 0 auto;
  max-width: 400px;
  min-height: 25px;
  height: 25px;
  overflow: hidden;
  border-radius: 4px;
  opacity: .6;
  background-color: #eee;
  transition: all 1s;
}

@keyframes placeHolderShimmer {
  0% {
    background-position: -468px 0
  }
  100% {
    background-position: 468px 0
  }
}

.animated-background {
  animation-duration: 1.25s;
  animation-fill-mode: forwards;
  animation-iteration-count: infinite;
  animation-name: placeHolderShimmer;
  animation-timing-function: linear;
  background: darkgray;
  background: linear-gradient(to right, #eeeeee 10%, #dddddd 18%, #eeeeee 33%);
  background-size: 800px 104px;
  height: 100px;
  position: relative;
}
</style>
